import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { createPortal } from "react-dom";
import { SearchHeaderBanner } from "@jti/ui/components/Search/components/SearchHeaderBanner";
import { SearchHeaderButton } from "@jti/ui/components/Search/components/SearchHeaderButton";
import { usePortal } from "@jti/ui/hooks/usePortal";
import styles from "./Search.module.scss";
const Container = ({ children }) => {
    return _jsx("div", { className: "aem-content-container", children: children });
};
const Search = ({ resultsPage }) => {
    const [isSearchOpened, setIsSearchOpened] = useState(false);
    const searchContainer = usePortal("header-search");
    const openSearch = () => {
        setIsSearchOpened(true);
    };
    const closeSearch = () => {
        setIsSearchOpened(false);
    };
    return (_jsxs(_Fragment, { children: [_jsx(SearchHeaderButton, { isOpened: isSearchOpened, onClose: closeSearch, onOpen: openSearch }), searchContainer &&
                createPortal(_jsx("div", { className: styles.searchBannerContainer, children: _jsx(SearchHeaderBanner, { isOpened: isSearchOpened, onClose: closeSearch, resultsPageUrl: resultsPage, Container: Container }) }), searchContainer)] }));
};
export default Search;
//# sourceMappingURL=Search.js.map